import { TenantListFilters } from "~/types";
import * as APITypes from "~/API";

const resolveTenantAuthType = (record: APITypes.Tenant) =>
  record.type ?? APITypes.TenantType.ShadowTenant;

const resolveTenantStatus = (record: APITypes.Tenant) =>
  record.status ?? APITypes.TenantStatusType.InActive;

const tenantSearchBlob = (record: APITypes.Tenant) =>
  [record.firstName, record.middleName, record.lastName, record.email]
    .map((v) => (v ?? "").toLowerCase())
    .join(" ");

export const getFilteredTenantList = ({
  filters,
  tenantList,
}: {
  filters: TenantListFilters;
  tenantList: APITypes.Tenant[];
}): APITypes.Tenant[] => {
  let list = tenantList;

  if (filters.status) {
    list = list.filter((t) => resolveTenantStatus(t) === filters.status);
  }

  if (filters.type) {
    list = list.filter((t) => resolveTenantAuthType(t) === filters.type);
  }

  if (filters.search?.trim()) {
    const q = filters.search.trim().toLowerCase();
    list = list.filter((t) => tenantSearchBlob(t).includes(q));
  }

  return list;
};
